export default __webpack_public_path__ + "70ca89c989dd1c266b0e4d84d4ace27c.glb";